import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import RouteContext from 'src/routes/context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { setSelectedLegacyVariants } from 'src/areas/product/actions/product';
import {
  VariantGroup as VariantGroupType,
  Variant as VariantType,
} from 'src/types';
import { trackProductVariantClick } from 'src/areas/product/components/tracking';
import { LegacyVariantGroup } from './legacy-variant-group';

export const LegacyVariants: React.FC<IVariants> = ({ variants }) => {
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const dispatch = useDispatch();
  const { selectedFilters, selectedCondition } = useContext(
    PriceListFilterContext
  );

  const handleSelectedVariant = (
    group: VariantGroupType,
    variant: VariantType | null
  ) => {
    const selectedVariants = variant && variant.id !== 0 ? [variant.id] : null;
    dispatch(setSelectedLegacyVariants(selectedVariants));
    trackProductVariantClick(group, variant);
    routeDispatch({
      type: 'PRODUCT_LEGACY_VARIANTS',
      variants: selectedVariants,
      options: { ...selectedFilters },
      condition: selectedCondition,
    });
  };

  return (
    <>
      {variants.map(group =>
        group.variants?.length ? (
          <LegacyVariantGroup
            handleSelectedVariant={handleSelectedVariant}
            group={group}
            key={`${group.type}-${group.id}`}
          />
        ) : null
      )}
    </>
  );
};

interface IVariants {
  variants: VariantGroupType[];
}
